/**
 * Monitors scroll position and toggles a class on the header.
 *
 * @param {string} selector - The CSS selector for the element (default: 'header')
 * @param {string} className - The class to add when scrolled (default: 'scrolled')
 * @returns {function} A cleanup function to remove the event listener.
 */
export default function initScrollHeader(selector = 'header', className = 'scrolled') {
    const header = document.querySelector(selector);

    // Safety check: exit if element doesn't exist
    if (!header) {
        console.warn(`ScrollHeader: Element "${selector}" not found.`);
        return () => {};
    }

    let ticking = false;

    // 1. The DOM update logic
    const update = () => {
        header.classList.toggle(className, window.scrollY > 0);
        ticking = false;
    };

    // 2. The Event Listener (throttled)
    const onScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    };

    // 3. Init
    window.addEventListener('scroll', onScroll, { passive: true });
    update(); // Run once immediately

    // 4. Return cleanup
    return () => window.removeEventListener('scroll', onScroll);
}
